import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import PointersWithoutHeading from '../PointersWithoutHeading';
import cabnetImg from '../../assets/proposalImages/cabnet.png';
import gunControl from '../../assets/proposalImages/gun_control.png';
import automaticGun from '../../assets/proposalImages/gema_automatic_gun-2.png';
import manualGun from '../../assets/proposalImages/manual_gun.png';
import ig07 from '../../assets/proposalImages/IG07.png';
import ProposalImage from '../ProposalImage';
import hopperImg from '../../assets/proposalImages/HF100_hopper.png';
import aptiAir_ca12 from '../../assets/proposalImages/aptiAir_ca12.png';


// if (!gemaSection) return null;
export default function GemaSectionPart1({ gemaSection, gema, showCabinetImage = true, cabinetImageGap = 20 }) {
  if(!gema?.electrical_cabinet && !gema?.automatic_gun && !gema?.gun_control && !gema?.manual_gun && !gema?.injector && !gema?.hopper && !gema?.caster && !gema?.powder_hopper_control) return null;

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          <div className="quotation-no-break" style={{ marginBottom: 16 }}>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
              GEMA Automatic System
            </h2>
            <div className="quotation-yellow-divider" />
          </div>

          {gema?.electrical_cabinet && (
            <div className="quotation-section-block">
              <HeadingDescription heading="OptiFlex AS10 electrical cabinet (Manufactured Locally)" description={gema.electrical_cabinet.description} level={3} />
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: showCabinetImage ? '1fr auto' : '1fr',
                  gap: cabinetImageGap,
                  alignItems: 'start',
                }}
              >
                <div style={{ minWidth: 0 }}>
                  {gema.electrical_cabinet.items && gema.electrical_cabinet.items.length > 0 && (
                    <PointersWithoutHeading items={gema.electrical_cabinet.items} />
                  )}
                  {gema.electrical_cabinet.technical_specification?.power_supply && (
                    <TechnicalDataTable data={gema.electrical_cabinet.technical_specification.power_supply.data} title="Power supply" />
                  )}
                  {gema.electrical_cabinet.technical_specification?.technical_data && (
                    <TechnicalDataTable data={gema.electrical_cabinet.technical_specification.technical_data.data} title="Technical data" />
                  )}
                </div>
                {showCabinetImage && (
                  <div style={{ flexShrink: 0 }}>
                    <ProposalImage src={cabnetImg} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ maxWidth: 220 }} />
                  </div>
                )}
              </div>
            </div>
          )}
          {gema?.automatic_gun && (
            <div className="quotation-section-block">
              <HeadingDescription heading="OptiGun GA03 automatic gun" description={gema.automatic_gun.description} level={3} />
              <ProposalImage src={automaticGun} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ width: "60%", marginBottom: 20 }} />
              {gema.automatic_gun.items && gema.automatic_gun.items.length > 0 && (
                <PointersWithoutHeading items={gema.automatic_gun.items} />
              )}
            </div>
          )}
          {gema?.gun_control && (
            <div className="quotation-section-block">
              <HeadingDescription heading="3. OptiStar 4.0 CG20 gun control" description={gema.gun_control.description} level={3} />
              <div style={{ flexShrink: 0 }}>
                <ProposalImage src={gunControl} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ maxWidth: 336, marginBottom: 20 }} />
              </div>
              {gema.gun_control.items && gema.gun_control.items.length > 0 && (
                <PointersWithoutHeading items={gema.gun_control.items} />
              )}
            </div>
          )}


      
        </div>
      </div>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          {gema?.manual_gun && (
            <div className="quotation-section-block">
              <HeadingDescription heading="OptiSelect GM04 manual gun" description={gema.manual_gun.description} level={3} />
              <ProposalImage src={manualGun} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ width: "53%", marginBottom: 20 }} />
              {gema.manual_gun.items && gema.manual_gun.items.length > 0 && (
                <PointersWithoutHeading items={gema.manual_gun.items} />
              )}
            </div>
          )}
          {gema?.injector && (
            <div className="quotation-section-block">
              <HeadingDescription heading="OptiFlow IG07 injector" description={gema.injector.description} level={3} />
              <ProposalImage src={ig07} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ width: "53%", marginBottom: 20 }} />
              {gema.injector.items && gema.injector.items.length > 0 && (
                <PointersWithoutHeading items={gema.injector.items} />
              )}
            </div>
          )}
        </div>
      </div>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          {gema?.hopper && (
            <div className="quotation-section-block">
              <HeadingDescription heading="HF100 powder hopper (Manufactured Locally)" description={gema.hopper.description} level={3} />

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 20
                }}
              >
                {gema.hopper.items && gema.hopper.items.length > 0 && (
                  <PointersWithoutHeading items={gema.hopper.items} />
                )}
                <ProposalImage src={hopperImg} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ width: "53%", marginBottom: 20 }} />

              </div>
              {gema.hopper.technical_specification?.data && (
                <TechnicalDataTable data={gema.hopper.technical_specification.data} title="Technical data" />
              )}
            </div>
          )}
          {gema?.caster && (
            <div className="quotation-section-block">
              <HeadingDescription heading="Caster for HF powder hoppers" description={gema.caster.description} level={3} />
            </div>
          )}
          {gema?.powder_hopper_control && (
            <div className="quotation-section-block">
              <HeadingDescription heading="OptiAir CA12 powder hopper control" description={gema.powder_hopper_control.description} level={3} />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 20
                }}
              >
                {gema.powder_hopper_control.items && gema.powder_hopper_control.items.length > 0 && (
                  <PointersWithoutHeading items={gema.powder_hopper_control.items} />
                )}
                <ProposalImage src={aptiAir_ca12} wrapperStyle={{ marginBottom: 0 }} imgStyle={{ width: "53%", marginBottom: 20 }} />
              </div>

            </div>
          )}
        </div>
      </div>
    </>
  );
}
